import Glimmer, {GlimmerOffset} from "@components/Glimmer";
import React from "react";

const COUNT = 10;
const LoadingSlots = () => {
  return (
    <>
      {Array(COUNT)
        .fill(null)
        .map((_, i) => (
          <Glimmer
            key={`loading-${i}`}
            height="3rem"
            style={{borderRadius: "1.5rem"}}
            offset={GlimmerOffset.XS}
          />
        ))}
    </>
  );
};

export default React.memo(LoadingSlots);
